import { render, staticRenderFns } from "./qualityStats.vue?vue&type=template&id=5ca83d3a&scoped=true&"
import script from "./qualityStats.vue?vue&type=script&lang=js&"
export * from "./qualityStats.vue?vue&type=script&lang=js&"
import style0 from "./qualityStats.vue?vue&type=style&index=0&id=5ca83d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca83d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca83d3a')) {
      api.createRecord('5ca83d3a', component.options)
    } else {
      api.reload('5ca83d3a', component.options)
    }
    module.hot.accept("./qualityStats.vue?vue&type=template&id=5ca83d3a&scoped=true&", function () {
      api.rerender('5ca83d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionBank/qualityStats.vue"
export default component.exports